// derives the logged-in user's own group ids from the synced GroupMembership table,
// the same way App.tsx derives loggedInUserRole from tableData.Users
export const getLoggedInUserGroupIds = (tableData: ObjectStringKeyAnyValue | null, userData: ObjectStringKeyAnyValue | null): string[] => {
    if (!tableData?.GroupMembership || !userData) return []
    const loggedInUserId = userData['cognito:username']
    return Object.values(tableData.GroupMembership)
        .filter((row: any) => row.UserId === loggedInUserId)
        .map((row: any) => row.GroupId)
}
